export class TipoDocumento {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string,
    public readonly Codigo: string,
    public readonly Activo: boolean
  ) {}
}

export class SearchTipoDocumentoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string,
    public readonly Nombre: string,
    public readonly Codigo: string,
    public readonly VerSoloActivos: boolean | null
  ) {}
}
export class SaveTipoDocumentoDto {
  constructor(
    public readonly Codigo: string,
    public Nombre: string,
    public Activo: boolean
  ) {}
}

export class SearchTipoDocumentoResponse {
  constructor(
    public readonly count: number,
    public readonly result: TipoDocumento[]
  ) {}
}
